var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressbar-container"},[_c('div',{staticClass:"progressbar",style:({ width: _vm.progress + '%', backgroundColor: _vm.progressColor })},[_c('div',{staticStyle:{"position":"absolute","margin-top":"4px","width":"100%","text-align":"center"}},[_c('b',[_vm._v(_vm._s(Number(_vm.progress).toFixed(0))+" %")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }